import React, { Component } from 'react';
import { ScrollView, Text, View } from 'react-native';
import ContentLoader from "react-native-easy-content-loader";
import { TouchableOpacity } from 'react-native-gesture-handler';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from "universal-cookie";
import { removeUserToken } from '../../../redux/User/user.actions';
import AppFooter from '../../components/app-footer';
import AppHeader from '../../components/app-header';
import AuthenticationWrapper from '../../components/authentication-wrapper';
import Banner from '../../components/banner';
import HomeArchievedContent from '../../components/home-archived-content/index-pricing';
import WritersSlider from '../../components/home-news-letters/WritersSlider';
import HomeReadersQuote from '../../components/home-readers-quote';
import OurJournalism from '../../components/ourJournalism';
import PageBreak from '../../components/page-break';
import Seo from "../../components/seo-meta";
import ViewPlans from "../../components/view-plans";
// import SubscriptionPricingPlan from '../../components/subscription-pricing-plan';
import WhyTMCSection from '../../components/why-choose-tmc';
import { appStyles, article, button, Colors, Flex, FontFamily, Helpers, Margin, Padding, pageContent, Typo } from '../../styles/appStyles';
import apiHelpers from "../../utils/api-helpers";
import { helpers } from '../../utils/helpers';
import getImagePath from '../../utils/image-helper';
import { Mixpanel } from '../../utils/mixpanel';
import seoObj from "../../utils/seo-helper";

const SubscriptionPricingPlan = React.lazy(() => import('../../components/subscription-pricing-plan'));


const cookies = new Cookies();
const elementBG = getImagePath('img/welcome_bg.png');
const laptop = getImagePath('img/laptop.png');
const checkIcon = getImagePath('icons/check.png');

export class Subscription extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const { isAuthenticated, fetchToken } = this.props.auth
        let token = webView ? (process.browser ? (isAuthenticated ? fetchToken : false) : this.props.token) : this.props.user?.userData?.data?.token;
        let tokenSet = (token == undefined || token == '') ? false : true;
        this.state = {
            token: tokenSet ? token : false,
            pageLoader: this.props.postData ? false : true,
            showErrorModal: false,
            enableUpgradeModal: false,
            enableCancelSubModal: false,
            plansData: false,
            userSubscription: false,
            teamSubscription: false,
            activeSubscription: false,
            country: false,
            pricingPlanRefreshKey: false,
            bannerTitle: 'Become a TMC subscriber',
            plansTitle: 'Choose your subscription',
            archivedStories:[],
            writers:false,
        }

        this.subscriptionLayout = 0;
    }

    componentDidMount = () => {
        const { token } = this.state;
        if (token) {
            this.getUserInfo();
        } else {
            this.getSubscriptionPlans();
        }
        this.getStaticContent();
        this.getWriters();
        this.getArchivedStories();
    }

    componentDidUpdate = (prevProps) => {
        let webView = helpers.isWeb();
        let token = webView ? this.props.auth.fetchToken : this.props.user?.userData?.data?.token;
        if (!(this.props.searchQuery && (this.props.searchQuery.includes("subscribe=") || this.props.searchQuery.includes("buy-credits=true"))) && ((token && token != this.state.token) || ((token == undefined || token == '') && this.state.token != false)) || (!helpers.isWeb() && prevProps.app.refreshScreen != this.props.app.refreshScreen)) {
            this.setState({
                token: (token == undefined || token == '') ? false : token,
                pageLoader: true
            }, () => {
                if (this.state.token) {
                    this.getUserInfo(true);
                } else {
                    this.getSubscriptionPlans();
                }
            });
        }
    }

    refreshPage = () => {
        if (!this.state.token) {
            this.getUserInfo();
        }
    }

    scrollToTop = (scroll) => {
        if (scroll) {
            if (helpers.isWeb()) {
                setTimeout(function () {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }, 2);
            }
        }
    }

    segregateWriters = (writerList) => {
        let writers = [], contributors = [];
        writerList.map((writer) => {
            if (writer.roles.includes("contributor")) {
                contributors.push(writer);
            } else {
                writers.push(writer);
            }
        })
        return { writers: writers };
    }
  
    getWriters = () => {
        this.setState({ showErrorModal: false });
        const { token } = this.state;
        let endpoint = `/authors`;
        let body = {
            // limit: 3,
            sort_on: 'name',
            sort_by: 'asc',
            filters: [{"key": "roles", "value": ["editor"] }]
        }
        apiHelpers
            .apiRequest(endpoint, body, "POST", true)
            .then((res) => {
                if (res.success && res.code == 'author_found') {
                    // this.setState({ writers: res.data.author });
                    let allWriters = this.segregateWriters(res.data.author);
                    this.setState({
                        // writers: allWriters['writers'],
                        writers: allWriters.writers,
                        contributorData: allWriters['contributors'],
                       
                    });
                }
                else {
                    // this.setState({ showErrorModal: true, pageLoader: false });
                    console.log('Error=>>', JSON.stringify(res));
                }
            })
            .catch((error) => {
                // this.setState({ showErrorModal: true, pageLoader: false });
                console.log('Error=>> down', JSON.stringify(error));
            });
    }

    getUserInfo = async(scroll) => {
        this.scrollToTop(scroll);
        const { token } = this.state;
        let endpoint = `/profile`;
        let body = {
            request_group: ["subscription"]
        }
       await apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
                if (res.code == 'access_denied') {
                    // this.authTokenExpired();
                    return false;
                }
                let userSubscription = (!res.data.subscription || JSON.stringify(res.data.subscription) == '{}') ? false : res.data.subscription;
                let teamSubscription = (!res.data.team_subscription || JSON.stringify(res.data.team_subscription) == '{}') ? false : res.data.team_subscription;
                let activeSubscription = ((userSubscription && userSubscription.status != 'expired') || (teamSubscription && teamSubscription.is_team_member && teamSubscription.status != 'expired')) ? true : false;
                if (res.success) {
                    this.setState({
                        userSubscription: userSubscription,
                        teamSubscription: teamSubscription,
                        activeSubscription: activeSubscription,
                        bannerTitle: activeSubscription ? 'Thanks for being a TMC subscriber!' : 'Become a TMC subscriber',
                        plansTitle: activeSubscription ? 'Active subscription plans' : 'Choose your subscription'
                    });
                    this.getSubscriptionPlans(res.data)
                } else {
                    console.log('Error=>>', res);
                    this.setState({
                        showErrorModal: true,
                        pageLoader: false,
                    });
                }
            })
            .catch((error) => {
                console.log('Error=>>', error);
                this.setState({
                    showErrorModal: true,
                    pageLoader: false,
                });
            });
    }

    getSubscriptionPlans = (profileData) => {
        const { token } = this.state;
        let endpoint = `/plans/default`;
        let body = {
            filters: {
                tmc_group: ["individual", "credit"]
            },
            rank_sort:"ASC"
        }
        if (profileData && profileData?.subscription?.plan) {
            body.filters.plan_gte = profileData.subscription.plan.id;
        }
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
                if (res.success) {
                    let creditPlan = res.data.plans.credit[0];
                    this.setState({
                        plansData: (profileData && profileData?.team_subscription?.is_team_member) ? { individual: [] } : res.data.plans,
                        country: res.data.country,
                        pricingPlanRefreshKey: !this.state.pricingPlanRefreshKey,
                        pageLoader: false,
                        creditPlan: creditPlan
                    });
                } else {
                    console.log('Error=>>', res);
                    this.setState({
                        showErrorModal: true,
                        pageLoader: false,
                    });
                }
            })
            .catch((error) => {
                console.log('Error=>>', error);
                this.setState({
                    showErrorModal: true,
                    pageLoader: false,
                });
            });
    }

    authTokenExpired = () => {
        if (helpers.isWeb()) {
            let cookieDate = new Date(Date.now() - 1);
            cookies.set('token', '', { path: '/', expires: cookieDate });
            this.props.navigateToScreen('/sign-in?redirect=/pricing');
        } else {
            this.props.removeUserToken();
            this.props.navigation.navigate('/sign-in', { redirect: 'subscriptions', verifyRedirect: '/pricing' });
        }
    }

    goToLogin = () => {
        if (helpers.isWeb()) {
            this.props.navigateToScreen('/sign-in?redirect=/pricing');
        } else {
            this.props.navigation.navigate('/sign-in', { redirect: 'subscriptions', verifyRedirect: '/pricing' });
        }
    }

    showPageLoader = () => {
        const webView = helpers.isWeb();
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        return (
            <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull, helpers.isDesktop() && { marginBottom: 100 }]}>
                <ContentLoader
                    containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                    active={true}
                    pHeight={[50]}
                    title={false}
                    pRows={1}
                    pWidth={['100%']}
                    paragraphStyles={{ marginBottom: 20, marginTop: 40 }}
                    animationDuration={400}
                    primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                    secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                />
                <ContentLoader
                    containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                    active={true}
                    pHeight={[400]}
                    title={false}
                    pRows={5}
                    pWidth={['100%']}
                    paragraphStyles={{ marginBottom: 60, marginTop: 0 }}
                    animationDuration={400}
                    primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                    secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                />
                <ContentLoader
                    containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                    active={true}
                    pHeight={[50]}
                    title={false}
                    pRows={1}
                    pWidth={['100%']}
                    paragraphStyles={{ marginBottom: 20, marginTop: 40 }}
                    animationDuration={400}
                    primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                    secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                />
                <ContentLoader
                    containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                    active={true}
                    pHeight={[70]}
                    title={false}
                    pRows={3}
                    pWidth={['100%']}
                    paragraphStyles={{ marginBottom: 20, marginTop: 40 }}
                    animationDuration={400}
                    primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                    secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                />
                <View>
                    <ContentLoader
                        containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 40 }}
                        active={true}
                        pHeight={[80]}
                        title={false}
                        pRows={1}
                        pWidth={['100%']}
                        paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
                        animationDuration={400}
                        primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                        secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                    />
                </View>
                <View style={[Flex.row]}>
                    <View style={{ flex: 0.4 }}>
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[200]}
                            title={false}
                            pRows={1}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                    </View>
                    <View style={[Margin.ml_2, { flex: 0.6 }]}>
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[50]}
                            title={false}
                            pRows={1}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[20]}
                            title={false}
                            pRows={2}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[30]}
                            title={false}
                            pRows={2}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 0, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                    </View>
                </View>
                <View style={[Flex.row]}>
                    <View style={{ flex: 0.4 }}>
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[200]}
                            title={false}
                            pRows={1}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                    </View>
                    <View style={[Margin.ml_2, { flex: 0.6 }]}>
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[50]}
                            title={false}
                            pRows={1}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[20]}
                            title={false}
                            pRows={2}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[32]}
                            title={false}
                            pRows={2}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 0, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                    </View>
                </View>
                <View style={[Flex.row]}>
                    <View style={{ flex: 0.4 }}>
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[200]}
                            title={false}
                            pRows={1}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                    </View>
                    <View style={[Margin.ml_2, { flex: 0.6 }]}>
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[50]}
                            title={false}
                            pRows={1}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[20]}
                            title={false}
                            pRows={2}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                        <ContentLoader
                            containerStyles={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 0 }}
                            active={true}
                            pHeight={[32]}
                            title={false}
                            pRows={2}
                            pWidth={['100%']}
                            paragraphStyles={{ marginBottom: 0, marginTop: 0 }}
                            animationDuration={400}
                            primaryColor={darkMode ? 'rgba(45, 48, 45,1)' : 'rgba(220, 220, 220, 1)'}
                            secondaryColor={darkMode ? 'rgba(45, 48, 45,0.8)' : 'rgba(200, 200, 200, 1)'}
                        />
                    </View>
                </View>
            </View>
        )
    }

    getStaticContent = () => {
        const { token } = this.state;
        let endpoint = `/static-content`;
        let body = {
            content: ["readers_quotes"]
        }
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, false)
            .then((res) => {
                if (res.success && res.code == 'content_found') {
                    this.setState({ staticContent: res.data });
                }
                else {
                    console.log('Error=>>', JSON.stringify(res));
                }
            })
            .catch((error) => {
                console.log(error);
                console.log('Error=>> down', JSON.stringify(error));
            });
    }

    viewAuthorDetails = (Slug) => {
        if (helpers.isWeb()) {
            this.props.navigateToScreen('/writers/' + Slug);
        } else {
            this.props.navigation.navigate('writer-single', { writerSlug: Slug });
        }
    }

    navigateToTag = (slug) => {
        if (helpers.isWeb()) {
            this.props.navigateToScreen('/tags/' + slug);
        } else {
            this.props.navigation.navigate('tags-archive', { archiveSlug: slug });
        }
    }

    subscribeToPlan = (subscribtionId, subscribtion, country) => {
        try {
            if (subscribtion.tmc_group == 'individual') {
                Mixpanel.track('click_select_plan_btn', { plan: subscribtion.name, price: subscribtion.price, discount: subscribtion.discount && subscribtion.discount.amount ? 'yes' : 'no' });
            }
            else if (subscribtion.tmc_group == 'credit') {
                Mixpanel.track('click_privilege_credits_btn', { price: subscribtion.price, discount: subscribtion.discount && subscribtion.discount.amount ? 'yes' : 'no' });
            }

        }
        catch (error) {
            console.log('mix panel error =>', error);
        }
        this.refs.header.showSubscriptionPlan(subscribtionId, subscribtion, country);
    }

    goToSignUp = (email) => {
        if (helpers.isWeb()) {
            this.props.navigateToScreen('/sign-up?redirect=/pricing' + (email ? ('&email=' + email) : ''));
        } else {
            this.props.navigation.navigate('/sign-up', { redirect: '/pricing', verifyRedirect: '/pricing', email: email });
        }
    }

    trackReadTerms = () => {
        // try {
        //     if(helpers.isWeb()) {
        //         Mixpanel.track('click_read_tc');
        //     }
        // }
        // catch(error) {
        //     console.log('mix panel error =>', error);
        // }
    }

    trackThemeClick = (theme) => {
        // try {
        //     if(helpers.isWeb()) {
        //         Mixpanel.track('click_theme', { theme : theme });
        //     }
        // }
        // catch(error) {
        //     console.log('mix panel error =>', error);
        // }
    }

    renderPageContent = () => {
        const { plansData, userSubscription, teamSubscription, activeSubscription, country, pricingPlanRefreshKey, staticContent, writerData, bannerTitle, plansTitle, token, creditPlan } = this.state;

        let webView = helpers.isWeb();
        let sectionTitle = {
            title: 'Get all the news from our categories'
        }

        let btnClickTerms, btnClickStudents;
        const { navigation } = this.props;
        if (helpers.isWeb()) {
            btnClickTerms = {
                to: "/terms-and-conditions"
            }
        } else {
            btnClickTerms = {
                onPress: () => navigation.navigate('/terms-and-conditions')
            }
        }

        if (helpers.isWeb()) {
            btnClickStudents = {
                to: "/student-subscription"
            }
        } else {
            btnClickStudents = {
                onPress: () => navigation.navigate('/student-subscription')
            }
        }

        let subInfoBox = {
            title: 'Get upto date with the latest stories',
            subtitle: 'Subscribe to TMC now',
            btnText: 'SUBSCRIBE'
        }
        if (activeSubscription) {
            subInfoBox.subtitle = null;
            subInfoBox.btnText = 'VIEW LATEST STORIES'
        }
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        return (
            <View>
                
                <View style={{ marginBottom: helpers.isDesktop() ? 0 : 0 }}>
                    <Banner bgColor={darkMode ? Colors.darkBlackColor : '#FFF4F1'} 
                    title={!token ? bannerTitle:"Upgrade your subscription"} 
                    darkMode={darkMode} />
                </View>
                { plansData &&
                <View
                    onLayout={event => {
                        const layout = event.nativeEvent.layout;
                        this.subscriptionLayout = layout.y;
                    }}
                >
                    <View style={[{ backgroundColor: '#FAFAFA', height: 418, position: 'absolute', left: 0, right: 0, top: 0 }, darkMode && { backgroundColor: Colors.darkBlackColorBg }]} />
                    <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, { marginBottom: helpers.isDesktop() ? 50 : 0 }, helpers.isDesktop() && { paddingTop: 60 }]}>
                       {helpers.isDesktop()&& <View style={[article.headerWrapper]}>
                            <View style={[Flex.alignCenter, helpers.isDesktop() && Margin.mb_3, !helpers.isDesktop() && Margin.mb_2, !helpers.isDesktop() && Padding.pt_3, { width: helpers.isWeb() ? 'fit-content' : '100%', marginLeft: 'auto', marginRight: 'auto' }]}>
                                <View style={[Padding.pl_1,Padding.pr_1, Helpers.titleBgWrap, { backgroundColor: 'rgba(250 250 250,1)' }]}>
                                    <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, { fontSize: 18, marginBottom: 2 }, { fontFamily: FontFamily.abrilFatface }, { fontSize: helpers.isDesktop() ? 46 : 32, lineHeight: helpers.isDesktop() ? 55 : 47, color: helpers.isDesktop()? "#000000" :'#051462' }, webView && { textTransform: 'regular' }, darkMode && { color: Colors.lightWhite }]}>{userSubscription?"Upgrade your subscription":plansTitle}</Text>
                                </View>
                                { helpers.isDesktop() ? <PageBreak style={[!webView && { width: '60%' }]} darkMode={darkMode} size ="small"/>:""}
                                {userSubscription && 
                                    <View style={[Padding.pl_1,Padding.pr_1, Helpers.titleBgWrap, { backgroundColor: 'rgba(250 250 250,1)' }]}>
                                        <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, { fontSize: 18, marginBottom: 2 }, { fontFamily: FontFamily.Matteo }, { fontSize: helpers.isDesktop() ? 18 : 8, lineHeight: helpers.isDesktop() ? 32 : 26, color: helpers.isDesktop()? "#000000" :'#051462' }, webView && { textTransform: 'regular' }, darkMode && { color: Colors.lightWhite }]}>
                                            {`Your current plan will expire on ${userSubscription.end_date.split('T')[0]}.`}
                                        </Text>
                                    </View>
                                }
                                
                            </View>
                        </View>}

                        <View style={[!helpers.isDesktop() && Padding.pt_0, !helpers.isDesktop() && Padding.pb_2, { maxWidth: 960, marginLeft: 'auto', marginRight: 'auto' }, !helpers.isDesktop() && { paddingHorizontal: 20 }, helpers.isDesktop() && Margin.mb_4]}>

                            {/* <View style={[!helpers.isDesktop() && Padding.pb_2, Flex.alignCenter, !helpers.isDesktop() && Flex.alignStart]}>
                                <View style={[!helpers.isDesktop() && Padding.pb_2]}>
                                    <Text style={[{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 18 : 22, color: '#000000', textAlign: 'center', marginBottom: helpers.isDesktop() ? 24 : 0, letterSpacing: 0.3 }, darkMode && { color: Colors.lightWhite }]}>Your current plan will expire on DD MM YY.</Text>
                                </View>
                                
                            </View> */}

                        </View>
                        <React.Suspense fallback={<Text>Loadig...</Text>}>


                        <SubscriptionPricingPlan premium={token?'prelogout':'non'} key={pricingPlanRefreshKey} planPage={true} plansData={plansData} userSubscription={userSubscription} teamSubscription={teamSubscription} country={country} showSubscriptionPlan={(subscribtionId, subscribtion, country) => this.subscribeToPlan(subscribtionId, subscribtion, country)} hidePagebreak={true} sidePanel={false} navigateScreen={(pushProp) => this.navigateScreen(pushProp)} subscriptionPage={true} darkMode={darkMode} goToLogin={this.goToLogin} showSignIn={true} showCreditPlan={activeSubscription && userSubscription?.plan.id == 'annual-plan-in' ? false : true} creditPlan={creditPlan} pricingPage={true} />

                        </React.Suspense>
                        {/* <View style={[{ paddingHorizontal: 20 }, Margin.mt_1, Flex.row, Flex.alignCenter, Flex.justfiyCenter, Flex.FlexWrap]}>
                            <Text style={{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 16 : 13, lineHeight: helpers.isDesktop() ? 32 : 22, color: darkMode ? Colors.lineColor : 'rgba(106, 106, 106, 1)', textAlign: 'center', position: 'relative', top: 1 }}>Full </Text>
                            <TouchableOpacityLink {...btnClickTerms} handleClick={() => this.trackReadTerms()}>
                                <Text style={{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 16 : 13, lineHeight: helpers.isDesktop() ? 22 : 20, textDecorationLine: 'underline', color: darkMode ? Colors.lineColor : '#6A6A6A', textAlign: 'center' }}>Terms and Conditions</Text>
                            </TouchableOpacityLink>
                            <Text style={{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 16 : 13, lineHeight: helpers.isDesktop() ? 22 : 20, color: darkMode ? Colors.lineColor : 'rgba(106, 106, 106, 1)', textAlign: 'center' }}> apply to all subscriptions.</Text>
                        </View> */}

                    </View>
                </View>
                }

                <View style={{ marginBottom: helpers.isDesktop() ? 0 : 0 }}>
                    <ViewPlans navigateScreen={(pushProp) => this.navigateScreen(pushProp)} darkMode={darkMode} />
                </View>

                {/* {(plansData?.credit && (activeSubscription == false)) && <View style={{ marginBottom: helpers.isDesktop() ? 150 : 60, }}>
                    <ReadyToSubscribe plan={plansData.credit} country={country} subscribeToPlan={(subscribtionId, subscribtion, country) => this.subscribeToPlan(subscribtionId, subscribtion, country)} darkMode={darkMode} />
                </View>
                } */}
                


                {/* Our Journalisam section */}
               
                {!token ?<View style={{marginVertical:helpers.isDesktop()?0:50}}> <OurJournalism darkMode={darkMode} /></View>:""}

                {!token ? <WhyTMCSection subscription={true} darkMode={darkMode} />:""}


                {/* <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200]}>
                    <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, helpers.isDesktop() && { paddingHorizontal: 20 }]}>
                        <HomePopularCategories transparentBg={true} data={sectionTitle} subscription={true} trackThemeClick={(theme) => this.trackThemeClick(theme)} getTagClick={(slug) => this.navigateToTag(slug)} darkMode={darkMode} />
                    </View>
                </View> */}

                {/* {writerData && writerData.length > 0 &&

                    <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, helpers.isDesktop() && { paddingHorizontal: 20 }, !helpers.isDesktop() && { marginTop: 40 }]}>
                        <View style={[Flex.alignCenter, Padding.pt_4, Padding.pb_4, { width: helpers.isWeb() ? 'fit-content' : '100%', marginLeft: 'auto', marginRight: 'auto' }]}>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 34 : 20, lineHeight: helpers.isDesktop() ? 40 : 20, fontFamily: FontFamily.abrilFatface, paddingBottom: 8, color: '#000' }, darkMode && { color: Colors.lightWhite }]}>Written by leading  journalists</Text>
                            <PageBreak style={[!webView && { width: '65%' }]} darkMode={darkMode} />
                        </View>

                        {helpers.isDesktop() ?
                            <View style={[Flex.row, Flex.FlexWrap]}>
                                {writerData.map((citem, index) => {
                                    return (
                                        <AuthorItem viewAuthor={(slug) => this.viewAuthorDetails(slug)} single={index == 0 ? true : false} key={`authorItem${index}`} data={citem} subscription={true} about={true} showArrow={true} teamWriters={true} require={false} darkMode={darkMode} />
                                    )
                                })
                                }
                            </View>
                            :
                            <View style={[Flex.row, Flex.FlexWrap]}>
                                {writerData.map((citem, index) => {
                                    return (
                                        <AuthorItem viewAuthor={(slug) => this.viewAuthorDetails(slug)} single={index == 0 ? true : false} key={`authorItem${index}`} data={citem} subscription={true} about={true} showArrow={false} teamWriters={true} require={false} darkMode={darkMode} />
                                    )
                                })
                                }
                            </View>
                        }
                    </View>
                } */}

                {/* get all news from section */}
                
               {!token? 
         
               
               <><View style={[Margin.mb_2, Margin.mt_2, !helpers.isDesktop() && Margin.mb_3, Flex.row,Flex.justfiyCenter, !helpers.isDesktop() && Flex.justfiyCenter, helpers.isDesktop() && Padding.ph_2]}>
                        <View style={[!helpers.isDesktop() && { backgroundColor: darkMode ? Colors.darkBlackColorBg : 'white', zIndex: 1, paddingHorizontal: 20 }]}>
                            <View style={[ helpers.isDesktop() && { marginLeft: 25, marginRight: 25 },helpers.isDesktop() && Helpers.borderBottom, darkMode && { borderBottomColor: Colors.lineColor }]}>
                                <Text style={[pageContent.sectionTitle, helpers.isDesktop() && pageContent.sectionTitleDesktop, helpers.isDesktop() && { marginRight: 0 }, helpers.isDesktop() && { paddingBottom: 5 },!helpers.isDesktop()&&{fontSize:24,lineHeight:36,color:'#051462',width:'70%',textAlign:'center',margin:'auto'}, { marginBottom: 2, color: '#000' }, darkMode && { color: Colors.lightWhite }]}>Get all the news from our categories</Text>
                            </View>
                        </View>
                    </View>
                
                    <View 
                        style={[Margin.mb_4,Flex.row,Flex.justfiyCenter, Flex.FlexWrap ,{ maxWidth: 1200, marginLeft: 'auto', marginRight: 'auto' }]}
                        onClick={(event)=>{
                            // this.props.history.push(`/category/${event.target.innerHTML}`)
                        }}  
                    >          
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]} >
                                Startups
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Fintech
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            E-Commerce
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Retail
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Media
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Technology
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Telecom
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Edtech
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            IT
                            </Text> 
                        </TouchableOpacity>
                        <TouchableOpacity> 
                            <Text style={[button.outlineButtonPurple,{paddingHorizontal:31, paddingVertical:10, fontSize:24, lineHeight:24},!helpers.isDesktop()&&{paddingHorizontal:10, paddingVertical:5, fontSize:14, lineHeight:16}]}>
                            Banking & Finance
                            </Text> 
                        </TouchableOpacity>
                    </View>
                    </>
                :""}
                {!userSubscription && <View style={[{ marginBottom: helpers.isDesktop() ? 50 : 0 }]}>
                    {
                        staticContent && staticContent.readers_quotes && this.renderReadersQuotes()
                    }
                </View>}

                {/* {!token && <View style={{ marginBottom: helpers.isDesktop() ? 140 : 0 }}>
                    <ReadFromArchives goToSignUp={(email) => this.goToSignUp(email)} subscription={true} darkMode={darkMode} />
                </View>} */}

                {/* {token && <View style={{ marginBottom: helpers.isDesktop() ? 190 : 0 }}>
                    <SubscriptionInfoBox data={subInfoBox} handleClick={() => this.handleInfoBoxClick()} darkMode={darkMode} />
                </View>} */}

                {!userSubscription &&
                    <View style={{ height: helpers.isWeb() ? 500 : 500 }} >
                        {this.state.writers && this.renderWriters()}
                    </View>
                }
            {!token&&<View style={{marginTop:helpers.isDesktop()?0:30}}>{this.renderArchivedStories()}</View>}


            </View>
        )
    }
     renderWriters=()=> {
        let { homeContent } = this.state;
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        let data = this.state.writers
        let data1 = []
        let data2 = []
        let data3 = []
        let data4 = [],data5=[],data6=[]
        Array.from(data).slice(0,3).map((item,index)=>{
             data1.push(item)
        })
        Array.from(data).slice(3,6).map((item,index) => {
            data2.push(item)
        })
        Array.from(data).slice(6,9).map((item,index) => {
            data3.push(item)
        })
        Array.from(data).slice(9,12).map((item,index) => {
            data4.push(item)
        })
        Array.from(data).slice(12,15).map((item,index) => {
            data5.push(item)
        })
        Array.from(data).slice(15,18).map((item,index) => {
            data6.push(item)
        })
        return (
            <WritersSlider categorySlug={'writers'} data={data} data1={data1} data2={data2} data3={data3} data4={data4} data5={data5} data6={data6} viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} viewCategory={(slug) => this.viewCategory(slug)} getNewsletterClick={(slug) => this.viewAuthor(slug)} home={true} darkMode={darkMode}/>
        )
    }
 renderArchivedStories=()=> {
        let { archivedStories } = this.state;
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        return (
            <HomeArchievedContent data={archivedStories} show={true} viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} viewCategory={(slug) => this.viewCategory(slug)} navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} trackSignUp={(email, position) => { this.trackSignUp(email, position) }} trackStoryClick={(title, data, position) => { this.trackStoryClick('click_starter_collection', title, data, position) }} darkMode={darkMode} />
        )
    }
     getArchivedStories = (excludeData = []) => {
        this.setState({
            showErrorModal: false,
        });
        let excludeList = excludeData.map((td) => {
            return td.id;
        })
        // const { token, whatsTrendingContent, latestStories, featuredStory, premiumStories, userStarterCollection } = this.state;
        // let excludeList = [];
        // if (latestStories) {
        //     excludeList = latestStories.map((ls) => {
        //         return ls.id;
        //     })
        // }
        // if (featuredStory) {
        //     excludeList.push(featuredStory.id);
        // }
        // if (whatsTrendingContent) {
        //     excludeList.push(whatsTrendingContent.id);
        // }

        let endpoint = `/stories`;
        let body = {
            limit: 1,
            exclude: excludeList,
            sort_on: 'date',
            sort_by: 'desc',
            // filters: [{ key: "single_category", value: true }]
            filters: [{ key: "is_privileged", value: false },{key: "single_category",value:true}]
        }
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, false)
            .then((res) => {
                if (res.success && res.code == 'story_found') {
                    this.setState({
                        archivedStories: res.data.story,
                        pageLoader: false
                    });
                }
                
            })
            .catch((error) => {
                console.log('Error=>> down', JSON.stringify(error));
            });
    }
    navigateScreen = (pushProp) => {
        if (helpers.isWeb()) {
            this.props.history.push(pushProp)
        }
        else {
            this.props.navigation.navigate(pushProp);
        }
    }

    renderReadersQuotes() {
        let { staticContent } = this.state;
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        return (
            <HomeReadersQuote data={staticContent.readers_quotes} viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} viewCategory={(slug) => this.viewCategory(slug)} subscriptionQuotes={true} darkMode={darkMode} pricing={true}/>
        )
    }

    handleInfoBoxClick = () => {
        let { activeSubscription } = this.state;
        if (activeSubscription) {
            if (helpers.isWeb()) {
                this.props.navigateToScreen('/all-stories')
            }
            else {
                this.props.navigation.navigate('/all-stories', { categorySlug: 'all' });
            }
        }
        else {
            this.scrollToSection(this.subscriptionLayout);
            try {
                if (helpers.isWeb()) {
                    Mixpanel.track('click_subscribe_btn');
                }
            }
            catch (error) {
                console.log("mix panel error =>", error);
            }
        }
    }

    scrollToSection = (position) => {
        let offsetPosition = position
        if (helpers.isWeb()) {
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        } else {
            this.appscrollview.scrollTo(offsetPosition)
        }

    }

    renderWebPage = () => {
        return (
            <>
                {this.renderPageContent()}
            </>
        )
    }

    renderAppPage = () => {
        return (
            <>
                <ScrollView style={{ flex: 1 }} ref={ref => this.appscrollview = ref}>
                    {this.renderPageContent()}
                </ScrollView>
            </>
        )
    }

    render() {
        const { pageLoader, showErrorModal, enableUpgradeModal, enableCancelSubModal } = this.state;
        const webView = helpers.isWeb();
        let redirectSlugs = {
            web: '/pricing',
            native: { redirect: '/pricing', verifyRedirect: '/pricing' }
        }
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        return (
            <View style={[webView && { paddingTop: helpers.isDesktop() ? 54 : 56 }, appStyles.appBg, Flex.fill, darkMode && appStyles.appBgDark]}>
                <Seo data={seoObj['subscriptions']} url={process.browser ? window.location.origin + window.location.pathname : ''} page="/pricing" />
                <AppHeader ref="header" history={this.props.history} searchQuery={this.props.searchQuery} locationHash={this.props.locationHash} navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} redirectSlugs={redirectSlugs} refreshPage={() => this.refreshPage()} isPricing={true} goBack={() => this.props.navigation.goBack()} darkMode={darkMode} />
                {pageLoader ? this.showPageLoader() :
                    (webView
                        ? this.renderWebPage()
                        : this.renderAppPage()
                    )
                }
                <AppFooter navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} Breadcrumbs={Breadcrumbs} />
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    const { app, user } = state;
    return { app, user }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ removeUserToken }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationWrapper(Subscription));

let Breadcrumbs = [
    {
        name: 'Home',
        link: '/'
    },
    {
        name: 'Individual Subscription'
    }
]